const initialState = [];

/**
 * @description
 *
 * Tracks actions dispatched that we need to track. Some components needs to know of a certain action before performing some action.
 *
 */
export default function (state = initialState, action) {
  if (action.meta && action.meta.actionDispatched) {
    return [...state
    // Remove the action if it already exists
    .filter(actionDispatched => actionDispatched !== action.meta.actionDispatched),
    // Adds the action to top of the list to maintain order
    action.meta.actionDispatched];
  }
  return state;
}